import { Pipe, PipeTransform } from '@angular/core';
import Article from '../../smoothr-web-app-core/models/Article';

@Pipe({
	name: 'showItemInfo',
	standalone: false,
})
export class ShowItemInfoPipe implements PipeTransform {
	transform(article: Article): any {
		const isInfo = article?.info && checkEntityValue(article.info);
		const isNutrition = article?.nutritions && checkEntityValue(article.nutritions);
		const isAllergens = article?.compound?.allergens && checkEntityValue(article.compound.allergens);
		const isAdditives = article?.compound?.additives && checkEntityValue(article.compound.additives);

		// if (!isInfo && !isNutrition && !isAllergens && !isAdditives) {

		return isAllergens;
	}
}

function filterServiceInfo(key: string) {
	if (key === '_id' || key === 'updatedAt' || key === 'createdAt' || key === 'unit' || key === 'new') {
		return false;
	}

	return true;
}

function checkEntityValue(entity: Record<string, any>) {
	return Object.entries(entity)
		.filter(([key, value]) => filterServiceInfo(key))
		.some(([key, value]) => value);
}
